<template lang="pug">
form(v-on:submit.prevent)
  .modal-card(style="width: auto")
    .modal-card-head
      .modal-card-title Update Available
    .modal-card-foot
      button.button.has-text-weight-semibold.is-fullwidth.is-primary(v-on:click="$parent.close(); impl(name)") Install
</template>

<script>
export default {
  props: {
    impl: {
      required: true,
      type: Function
    }
  }
}
</script>
